export default __webpack_public_path__ + "static/media/pre-op-6.379ca364.jpg";